"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitorComponent = void 0;
exports.MonitorComponent = {
    name: 'MonitorComponent',
    props: {
        monitor: {
            type: Object,
        },
        monitorExtra: {
            type: Object,
        },
    },
    render: function () {
        var _this = this;
        var slots = this.$slots.default;
        if (this.monitor) {
            slots === null || slots === void 0 ? void 0 : slots.forEach(function (slot) {
                var _a;
                var Ctor = (_a = slot.componentOptions) === null || _a === void 0 ? void 0 : _a.Ctor;
                var options = Ctor.options;
                var superOptions = Ctor.superOptions;
                if (options.directives.monitor || superOptions.directives.monitor) {
                    var data = slot.data || (slot.data = {});
                    var directives = (data === null || data === void 0 ? void 0 : data.directives) || (data.directives = []);
                    if (!directives.some(function (_a) {
                        var name = _a.name;
                        return name === 'monitor';
                    })) {
                        directives.push({ name: 'monitor', value: _this.monitor });
                    }
                    if (_this.monitorExtra) {
                        var attrs = (data === null || data === void 0 ? void 0 : data.attrs) || (data.attrs = {});
                        attrs['data-monitor-extra'] = JSON.stringify(_this.monitorExtra);
                    }
                }
            });
        }
        return slots;
    },
};
